import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import { Snackbar, Alert, CircularProgress, Grid } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

import HeaderBicicletas from "./components/HeaderBicicletas";

const Bicicletas = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
    action: null,
  });
  const [loading, setLoading] = useState(false);

  const showNotification = (message, severity = "success", options = {}) => {
    setSnackbar({
      open: true,
      message,
      severity,
      action: options.action || null,
      autoHideDuration: options.persist ? null : 6000,
    });
  };

  const showSuccess = (message) => showNotification(message, "success");
  const showError = (message, options = {}) => showNotification(message, "error", options);

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleIngreso = async (data) => {
    try {
      setLoading(true);
      setRefreshFlag((prev) => !prev);
      showSuccess(
        `Ingreso registrado exitosamente - Gancho #${String(data.ganchoId || "").padStart(2, "0")}`
      );
    } catch (error) {
      console.error("❌ Error al registrar ingreso:", error);
      showError(error.message || "Error al registrar el ingreso");
    } finally {
      setLoading(false);
    }
  };

  const handleSalida = async (data) => {
    try {
      setLoading(true);
      setRefreshFlag((prev) => !prev);
      showSuccess(
        `Salida registrada exitosamente - Gancho #${String(data.ganchoId || "").padStart(2, "0")}`
      );
    } catch (error) {
      console.error("❌ Error al registrar salida:", error);
      showError(error.message || "Error al registrar la salida");
    } finally {
      setLoading(false);
    }
  };

  const handleError = (errorMessage) => showError(errorMessage);
  const handleRefresh = () => setRefreshFlag((prev) => !prev);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.autoHideDuration || 6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        key={snackbar.message}
      >
        <Alert
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          action={snackbar.action}
          sx={{
            width: "100%",
            maxWidth: "500px",
            backgroundColor: snackbar.severity === "success" ? "#f0fff4" : "#fff5f5",
            color: snackbar.severity === "success" ? "#276749" : "#c53030",
            border: snackbar.severity === "success" ? "1px solid #c6f6d5" : "1px solid #fed7d7",
            boxShadow: 2,
          }}
        >
          <MDTypography variant="body1" fontWeight="bold">
            {snackbar.severity === "success" ? "¡Éxito!" : "Error"}
          </MDTypography>
          <MDTypography variant="body2">{snackbar.message}</MDTypography>
        </Alert>
      </Snackbar>

      <MDBox py={3}>
        <HeaderBicicletas
          onIngreso={handleIngreso}
          onSalida={handleSalida}
          refreshFlag={refreshFlag}
          onError={handleError}
          onRefresh={handleRefresh}
          loading={loading}
        />

        <MDBox mt={3} p={2} bgcolor="background.paper" borderRadius="8px">
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <CheckCircle fontSize="small" color="success" />
                <MDTypography variant="caption" color="textSecondary">
                  Estado del sistema: <strong>Operativo</strong>
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={8}>
              <MDTypography
                variant="caption"
                color="textSecondary"
                textAlign="right"
                display="block"
              >
                Última actualización: {new Date().toLocaleTimeString()}
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      {loading && (
        <MDBox
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bgcolor="rgba(255,255,255,0.7)"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex={9999}
        >
          <MDBox textAlign="center">
            <CircularProgress color="info" size={60} />
            <MDTypography variant="h6" mt={2}>
              Procesando...
            </MDTypography>
          </MDBox>
        </MDBox>
      )}
    </DashboardLayout>
  );
};

export default Bicicletas;
